import { render } from "./TheInstructions.vue?vue&type=template&id=06a8d6c8&scoped=true"
import script from "./TheInstructions.vue?vue&type=script&lang=js"
export * from "./TheInstructions.vue?vue&type=script&lang=js"

import "./TheInstructions.vue?vue&type=style&index=0&id=06a8d6c8&scoped=true&lang=css"

import exportComponent from "/Users/curtismensah/Projects/Litt/Brit/brit-fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06a8d6c8"]])

export default __exports__